import { initializeProvider } from "../../web/provider.js";
import { AppInsightsContext, ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { createBrowserHistory } from "history";
import { createContext, useState } from "react";
import { jsx } from "react/jsx-runtime";

//#region src/react/components/TelemetryProvider.tsx
const browserHistory = createBrowserHistory();
const reactPlugin = new ReactPlugin();
const TelemetryContext = createContext(null);
const getOrCreateInstance = (instrumentationKey, buildNumber = "", cloudRole) => {
	let instance;
	if (typeof window.telemetry !== "undefined") instance = window.telemetry;
	else {
		instance = initializeProvider(instrumentationKey, buildNumber, cloudRole);
		/** Expose the instance globally so components rendered outside this
		* provider's subtree (e.g. an ErrorBoundary wrapping it) can still
		* report telemetry. */
		window.telemetry = instance;
	}
	instance.addPlugin(reactPlugin);
	instance.updateConfig({ extensionConfig: { [reactPlugin.identifier]: { history: browserHistory } } });
	return instance;
};
const TelemetryProvider = ({ children, instrumentationKey, buildNumber = "", cloudRole }) => {
	const [instance, _] = useState(getOrCreateInstance(instrumentationKey, buildNumber, cloudRole));
	return /* @__PURE__ */ jsx(TelemetryContext.Provider, {
		value: { telemetryInstance: instance },
		children: /* @__PURE__ */ jsx(AppInsightsContext.Provider, {
			value: reactPlugin,
			children
		})
	});
};

//#endregion
export { TelemetryContext, TelemetryProvider };